<template>
  <div>23</div>
</template>

<script>
export default {
  name: 'bc-subject-tree'
}
</script>

<style scoped>

</style>
